import { LayoutWrapper } from "@/components/common/layout/LayoutWrapper"
import React, { useEffect } from "react"
import { Outlet } from "react-router-dom"
import { useConnect } from "wagmi"

export const MainLayout: React.FunctionComponent = () => {
  const { connectors, connect } = useConnect()

  useEffect(() => {
    if (localStorage.getItem("is_diver_wallet") === "true") {
      const connector = connectors.find(item => item.name === "DiverWallet")
      connector && connect({ connector })
    }
  }, [])

  return (
    <LayoutWrapper>
      <Outlet />
    </LayoutWrapper>
  )
}
